<!-- 活动设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="113px">
          <el-form-item label="会员手机号码:">
            <el-input
              v-model="queryParam.userPhone"
              placeholder="会员手机号码"
              style="width: 147px"
            ></el-input>
          </el-form-item>
          <el-form-item label="消费类型:" label-width="80px">
            <el-select placeholder="请选择" style="width: 147px">
              <el-option
                v-for="item in [
                  { label: 'A类型体验卡', value: 1 },
                  { label: 'B类型体验卡', value: 2 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-radio-group v-model="queryParam.radio">
              <el-radio :label="3">A门店</el-radio>
              <el-radio :label="6">B门店</el-radio>
              <el-radio :label="9">全部</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item style="margin-left: 30px">
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-search"
              @click="onBtnSearch()"
              >查 询</el-button
            >
            <el-button
              type="warning"
              size="medium"
              class="operator-btn2"
              icon="el-icon-refresh"
              @click="handleResetSearch()"
              style="margin-left: 30px"
              >重 置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="app-container-content">
      <!--    查询结果区域-->
      <div
        class="title-container"
        shadow="never"
        style="padding-top: 20px; display: none"
      >
        <!-- <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div> -->
        <div></div>
        <div>
          <!-- <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button> -->
        </div>
      </div>
      <div class="table-container" style="margin-top: 20px; padding-top: 20px">
        <el-table
          :data="tableData"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          v-loading="listLoading"
          ref="seleteTable"
          max-height="650"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="userPhone" label="手机号"></el-table-column>
          <el-table-column prop="childName" label="会员名"></el-table-column>
          <el-table-column prop="childMonth" label="月龄"></el-table-column>
          <el-table-column
            prop="introducerNum"
            label="介绍购卡总数"
          ></el-table-column>
          <el-table-column
            prop="totalCardNum"
            label="自购卡数"
          ></el-table-column>
          <el-table-column
            prop="totalCardMoney"
            label="自购金额"
          ></el-table-column>
          <el-table-column
            prop="cardEndTime"
            label="会员卡到期时间"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="lastSingInTime"
            label="最后上课时间"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="lastServiceTime"
            label="最后服务开始时间"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="lastPhotoCreateTime"
            label="最后上传照片时间"
            width="160"
          ></el-table-column>
          <el-table-column prop="" label="服务员工"></el-table-column>
          <el-table-column prop="" label="备注"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button @click="showSubList(scope.row)" plain size="small"
                >查看介绍信息</el-button
              > -->
              <el-button class="vip-button"
                type="text"
                size="small"
                @click="clickOpenSeeShow(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage"
      >
      </el-pagination>
    </div>
    <template v-if="visibleSeeShow">
      <el-dialog
        title="查看"
        :visible.sync="visibleSeeShow"
        width="800px"
        center
      >
        <stepCiom />
      </el-dialog>
    </template>
    <el-dialog
      title="介绍会员列表"
      :visible.sync="visibleDlg"
      width="80%"
      center
    >
      <div class="table-container" style="margin-top: 0px; height: auto">
        <el-table
          :data="subTableData"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          v-loading="subListLoading"
          ref="seleteTable"
          max-height="650"
          border
        >
          <el-table-column prop="userPhone" label="手机号"></el-table-column>
          <el-table-column prop="childName" label="会员名"></el-table-column>
          <el-table-column prop="childMonth" label="月龄"></el-table-column>
          <!-- <el-table-column prop="introducerNum" label="介绍购卡总数" ></el-table-column> -->
          <el-table-column
            prop="totalCardNum"
            label="自己购卡总数"
          ></el-table-column>
          <el-table-column
            prop="totalCardMoney"
            label="自己购卡金额"
          ></el-table-column>
          <el-table-column
            prop="cardEndTime"
            label="会员卡的失效时间"
          ></el-table-column>
          <el-table-column
            prop="lastSingInTime"
            label="最后上课时间"
          ></el-table-column>
          <el-table-column
            prop="lastServiceTime"
            label="最后服务时间"
          ></el-table-column>
          <el-table-column
            prop="lastPhotoCreateTime"
            label="最后上传照片时间"
          ></el-table-column>
          <!-- <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="showSubList(scope.row)" plain size="small">查看介绍信息</el-button>
          </template>
        </el-table-column> -->
        </el-table>
        <div class="pagination-container">
          <el-pagination
            background
            @size-change="handleSubSizeChange"
            @current-change="handleSubCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="querySubParam.pageNum"
            :page-size="querySubParam.pageSize"
            :page-sizes="querySubParam.pageSizes"
            :total="querySubParam.totalPage"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
/deep/ .el-table th.el-table__cell > .cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}
/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }
  .table-container {
    border: none;
    border-radius: 0px;
    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }
}
</style>

<script>
import globaldata from "../../utils/globaldata";
import commonUtils from "../../utils/commonUtils";
import {
  introduceUserList,
  introduceUserListByPhone,
} from "../../api/userChild";
import messageUtils from "../../utils/messageUtils";
import stepCiom from "./components/step";

export default {
  components: {
    stepCiom,
  },
  data() {
    return {
      visibleSeeShow: false,
      listLoading: true,
      //查询参数
      queryParam: {
        userPhone: "", //会员手机号码
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        //分页查询
        pageNum: 1, //当前第几页
        pageSize: 10,
        // pageSizes:[20,50,100],
      },

      querySubParam: {
        userPhone: "", //会员手机号码
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        //分页查询
        pageNum: 1, //当前第几页
        pageSize: 10,
        // pageSizes:[1,20],
      },

      totalPage: 1, //总共页数

      //查询区域默认展开
      activeName: 1,
      //新增任务信息

      //弹窗
      visibleDlg: false,
      visibleDlgChangePasswd: false,
      //表单结果
      tableData: [],
      subTableData: [],
      allWorker: [],
      subListLoading: false,
      subListPhone: "",

      multipleSelection: [],
      showData: {},
    };
  },
  created() {
    this.fitchList();
  },
  mounted() {
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
  },
  methods: {
    clickOpenSeeShow(row) {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.showData = row;
      this.visibleSeeShow = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleResetSearch() {
      this.queryParam = {
        userPhone: "", //会员手机号码
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        //分页查询
        pageNum: 1, //当前第几页
        pageSize: 10,
      };
    },
    getWorker(id) {
      for (let i = 0; i < this.allWorker.length; ++i) {
        if (this.allWorker[i].id == id) {
          return this.allWorker[i].name;
        }
      }
      return "";
    },
    getStoreWorkersInfo(list) {
      // console.info(list)
      this.allWorker.push({ id: null, name: "无" });
      this.allWorker = this.allWorker.concat(list);
    },
    //点击查询按钮
    onBtnSearch() {
      this.fitchList();
    },
    showSubList(row) {
      this.visibleDlg = true;
      this.querySubParam.userPhone = row.userPhone;
      this.fitchSubList();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.fitchList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.fitchList();
    },
    handleSubCurrentChange(val) {
      this.querySubParam.pageNum = val;
      this.fitchSubList();
    },
    handleSubSizeChange(val) {
      this.querySubParam.pageSize = val;
      this.fitchSubList();
    },
    refreshData(list) {
      this.tableData = list;
    },
    onBtnOK() {
      this.visibleDlg = false;
      this.fitchList();
    },
    onBtnCancel() {
      this.visibleDlg = false;
    },
    fitchList() {
      this.listLoading = true;
      introduceUserList(this.queryParam).then((response) => {
        this.listLoading = false;
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          this.listLoading = false;
          return;
        }
        this.queryParam.totalPage = data.totalPage;
        this.refreshData(data.list);
        this.listLoading = false;
      });
    },
    fitchSubList() {
      this.subListLoading = true;
      introduceUserListByPhone(this.querySubParam).then((response) => {
        this.subListLoading = false;
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.querySubParam.totalPage = data.totalPage;
        this.subTableData = data.list;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user/introducerList.vue